import {PaymentTransferType} from "../generated/graphql";
import {getPaymentMethodType, PaymentMethodData, PaymentMethodType} from "./getPaymentMethodType";

type PaymentMethodWithType = Partial<PaymentMethodData> & {type?: PaymentTransferType | null};

const TYPE_BY_TRANSFER_TYPE: Partial<Record<PaymentTransferType, PaymentMethodType>> = {
    [PaymentTransferType.SepaDebit]: "sepaDebit",
    [PaymentTransferType.Creditcard]: "creditCard",
    [PaymentTransferType.Paypal]: "payPal",
    [PaymentTransferType.Esr]: "esr",
    [PaymentTransferType.BankTransfer]: "bankTransfer",
    [PaymentTransferType.Cash]: "cash",
    [PaymentTransferType.Online]: "onlinePayment",
};

/**
 * Nur für die Anzeige: `getPaymentMethodType` leitet die Art aus den Feldern ab (Lastschrift braucht
 * IBAN und Kontoinhaber). Nach einem DSGVO-Löschantrag sind diese Felder leer, `type` bleibt; ohne
 * Rückgriff darauf stünde bei jeder Rate der Person „Keine“ statt „Lastschrift“. Buchhaltung und
 * Auswahl nutzen weiter `getPaymentMethodType`, dort zählt nur, was tatsächlich einziehbar ist.
 */
export const getDisplayedPaymentMethodType = (paymentMethod?: PaymentMethodWithType | null): PaymentMethodType => {
    const derived = getPaymentMethodType(paymentMethod as PaymentMethodData | null | undefined);

    if (derived !== "none" || !paymentMethod?.type) return derived;

    return TYPE_BY_TRANSFER_TYPE[paymentMethod.type] ?? "none";
};
